import React, { useState } from "react";

function Contact() {
  const email = "selina.mogicato@sunrise.net";
  const teamsUser = "selina.mogicato@sunrise.net";
  const locationText = "Thurgauerstrasse 101B, 8152 Glattpark (Opfikon)";
  const mapsQuery = encodeURIComponent(locationText);

  const [copied, setCopied] = useState(null); // "email" | "teams" | "location" | null
  const copy = async (what, value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(what);
      setTimeout(() => setCopied(null), 1200);
    } catch {}
  };

  return (
    <div className="min-h-screen bg-green-cloud">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header (styled like Changelog) */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-r from-sunrise-red to-sunrise-red/80 rounded-2xl flex items-center justify-center mr-4">
              <i className="fas fa-user-circle text-white text-2xl"></i>
            </div>
            <div>
              <h1 className="text-4xl font-bold text-grey-dusk">Contact</h1>
              <p className="text-gray-600 mt-2">
                Let’s connect across professional networks
              </p>
            </div>
          </div>
          <div className="w-24 h-1 bg-gradient-to-r from-sunrise-red to-sunrise-red/60 rounded-full mx-auto"></div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Email */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
            <div className="bg-gradient-to-r from-sunrise-red to-sunrise-red/80 text-white px-6 py-5">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                  <i className="fas fa-envelope text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-semibold">Email</h2>
                  <p className="text-white/80 text-sm">Direct message</p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <p className="text-grey-dusk font-medium break-words">{email}</p>
              <div className="mt-4 flex flex-wrap gap-3">
                {/* Standard: mailto */}
                <a
                  href={`mailto:${email}?subject=${encodeURIComponent(
                    "Hello Selina"
                  )}`}
                  className="relative z-10 inline-flex items-center px-4 py-2 rounded-lg bg-sunrise-red text-white hover:bg-sunrise-600 transition text-sm font-medium"
                >
                  <i className="fas fa-paper-plane mr-2" />
                  Send Email
                </a>

                {/* Copy bleibt */}
                <button
                  onClick={() => copy("email", email)}
                  className="relative z-10 inline-flex items-center px-4 py-2 rounded-lg bg-white text-grey-dusk border border-gray-200 hover:bg-gray-50 transition text-sm font-medium"
                >
                  <i
                    className={`mr-2 ${
                      copied === "email" ? "fas fa-check" : "fas fa-copy"
                    }`}
                  />
                  {copied === "email" ? "Copied" : "Copy"}
                </button>
              </div>
            </div>
          </div>

          {/* Teams */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
            <div className="bg-gradient-to-r from-sunrise-red to-sunrise-red/80 text-white px-6 py-5">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                  <i className="fab fa-microsoft text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-semibold">Teams</h2>
                  <p className="text-white/80 text-sm">
                    Chat in Microsoft Teams
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <p className="text-grey-dusk font-medium break-words">
                {teamsUser}
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <a
                  href={`https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(
                    teamsUser
                  )}`}
                  className="inline-flex items-center px-4 py-2 rounded-lg bg-sunrise-red text-white hover:bg-sunrise-600 transition text-sm font-medium"
                >
                  <i className="fas fa-comments mr-2" />
                  Open Chat
                </a>
                <button
                  onClick={() => copy("teams", teamsUser)}
                  className="inline-flex items-center px-4 py-2 rounded-lg bg-white text-grey-dusk border border-gray-200 hover:bg-gray-50 transition text-sm font-medium"
                >
                  <i
                    className={`mr-2 ${
                      copied === "teams" ? "fas fa-check" : "fas fa-copy"
                    }`}
                  />
                  {copied === "teams" ? "Copied" : "Copy"}
                </button>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden md:col-span-2">
            <div className="bg-gradient-to-r from-sunrise-red to-sunrise-red/80 text-white px-6 py-5">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                  <i className="fas fa-map-marker-alt text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-semibold">Location</h2>
                  <p className="text-white/80 text-sm">Office address</p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <p className="text-grey-dusk font-medium">{locationText}</p>
                <div className="flex flex-wrap gap-3">
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${mapsQuery}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center px-4 py-2 rounded-lg bg-sunrise-red text-white hover:bg-sunrise-600 transition text-sm font-medium"
                  >
                    <i className="fas fa-map mr-2" />
                    Open Maps
                  </a>
                  <button
                    onClick={() => copy("location", locationText)}
                    className="inline-flex items-center px-4 py-2 rounded-lg bg-white text-grey-dusk border border-gray-200 hover:bg-gray-50 transition text-sm font-medium"
                  >
                    <i
                      className={`mr-2 ${
                        copied === "location" ? "fas fa-check" : "fas fa-copy"
                      }`}
                    />
                    {copied === "location" ? "Copied" : "Copy"}
                  </button>
                </div>
              </div>

              {/* Map preview */}
              <div className="mt-5 overflow-hidden rounded-xl border border-gray-200">
                <iframe
                  title="map"
                  className="w-full h-56"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src={`https://www.google.com/maps?q=${mapsQuery}&output=embed`}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Profile / Connect With Me */}
        <div className="mt-12">
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
            <div className="bg-gradient-to-r from-sunrise-red to-sunrise-red/80 text-white px-6 py-5">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3">
                  <i className="fas fa-user text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-semibold">Connect With Me</h2>
                  <p className="text-white/80 text-sm">Let’s stay in touch</p>
                </div>
              </div>
            </div>

            <div className="p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-sunrise-red to-sunrise-600 text-white flex items-center justify-center text-lg font-bold mr-3">
                  S
                </div>
                <div>
                  <div className="text-grey-dusk font-semibold">
                    Selina Mogicato
                  </div>
                  <div className="text-gray-600 text-sm">
                    Application Developer
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed">
                Please feel free to contact me with any suggestions for
                improvement or bugs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
